import { decodeToken } from "./decodeToken";

/**
 * Adds the IsAiEnabled query parameter to score report URLs only if showaitutor is true from token
 * @param url - The score report URL
 * @returns The URL with IsAiEnabled=true parameter appended (only if showaitutor is true)
 */
export const addShowAITriggerToScoreReportUrl = (url: string | null | undefined): string => {
  if (!url) return url || '';
  
  // Check if showaitutor is set to true from token
  const token = decodeToken();
  const shouldAddIsAiEnabled = token && 
    token.hasOwnProperty("showaitutor") && 
    token.showaitutor.toLowerCase() === "true";
  
  // If showaitutor is not true, return URL as-is
  if (!shouldAddIsAiEnabled) {
    return url;
  }
  
  try {
    const urlObj = new URL(url);
    // Only add if it doesn't already exist
    if (!urlObj.searchParams.has('IsAiEnabled')) {
      urlObj.searchParams.set('IsAiEnabled', 'true');
    }
    return urlObj.toString();
  } catch (e) {
    // If URL parsing fails (e.g., relative URL), try simple string manipulation
    if (url.includes('IsAiEnabled')) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}IsAiEnabled=true`;
  }
};

